import { useEffect, useRef } from 'react';

/**
 * Hook that sets up an interval to repeatedly call a callback function.
 * @param {Function} callback - The function to be called at each interval.
 * @param {number?} delay - The delay (in milliseconds) between each interval. Pass null to stop the interval.
 */
export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
